import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
// import laptopImg from "../../Assets/frontend-framework-cover-removebg-preview.png";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
          I am an Air Force veteran who embarked on a transformative journey, transitioning from a career in dentistry, where I dedicated over 6 years of service, to the vibrant world of <span className="purple">Technology. </span>
             {/* <span className="purple"> </span> */}
             After my separation from the military, I initially pursued studies in biology,
             but serendipitously stumbled upon the captivating realm of software engineering – and it was love at first code.
            The sheer abundance of knowledge available at one's fingertips and the dynamic impact
            one can wield in an ever-evolving tech landscape are exhilarating concepts to me. Much like my experiences in healthcare, where every action directly impacted someone's well-being, in software engineering, I find gratification in witnessing the immediate impact of my contributions on systems, making processes more efficient
            and returning countless hours of time to those who would have otherwise invested it elsewhere.
            <br></br>
            My journey into software engineering was ignited by stumbling upon inspiring stories shared on platforms like Instagram, such as <span className="purple">@SalaryTransparentStreet </span> which fueled my curiosity and led me down an endless rabbit hole of educational content on YouTube.
            This relentless pursuit of knowledge ultimately propelled me to take a leap of faith and apply to a rigorous bootcamp at Hack Reactor with Galvanize. Today, as a software engineer, I am fueled by an unwavering passion to play a meaningful role in the continuous advancement of technology – not only to simplify the lives of others but also to contribute to a
            future where efficiency and innovation intertwine to drive positive change.
            <br />
            Also, I am a recent Graduate of Hack Reactor @ Galvanize
            <br />
            <br />
            Typically what I do aside from Coding I like to:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Watch Anime
            </li>
            <li className="about-activity">
              <ImPointRight /> Practice my fluency with Spanish then learn French once comfortable
            </li>
            <li className="about-activity">
              <ImPointRight /> Generally exploring and touch some grass🌴
            </li>
          </ul>
          {/* <img src={laptopImg} alt="about" className="img-fluid" /> */}
          {/* <p style={{ color: "rgb(155 126 172)" }}>
            "Menifesting things to achive goals!"{" "}
          </p>
          <footer className="blockquote-footer"> Shivani</footer> */}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
